import type { ReactNode } from 'react'
import { useCanAdministerSyncs, usePulseMe } from '@/app/auth/use-pulse-me'
import { Loader2 } from '@/components/icons'

export function AdminRoute({ children }: { children: ReactNode }) {
  const me = usePulseMe()
  const canEnter = useCanAdministerSyncs()

  if (me.isLoading) {
    return (
      <div className="flex items-center gap-2 py-16 text-[12.5px] text-[color:var(--muted-foreground)]">
        <Loader2 className="size-4 animate-spin" />
        Checking access…
      </div>
    )
  }

  if (!canEnter) {
    return (
      <div className="flex flex-col items-start gap-2 py-16">
        <h1 className="text-[15px] font-semibold">Not allowed</h1>
        <p className="text-[12.5px] text-[color:var(--muted-foreground)]">
          Only Admins and Superadmins can run channel syncs.
        </p>
      </div>
    )
  }

  return <>{children}</>
}
